/**
 * EmptyState Component - For empty data states
 */

import React from 'react';
import { Inbox } from 'lucide-react';

const EmptyState = ({
  title = 'No data available',
  description = 'There is nothing to show here yet.',
  icon = null,
  action = null,
  className = '',
  ...props
}) => {
  const Icon = icon || Inbox;

  return (
    <div className={`text-center py-12 px-4 ${className}`} {...props}>
      <div className="w-16 h-16 bg-neutral-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <Icon size={28} className="text-neutral-400" />
      </div>
      <h3 className="text-lg font-semibold text-ink mb-2">{title}</h3>
      <p className="text-sm text-muted max-w-sm mx-auto">{description}</p>
      {action && (
        <div className="mt-6">
          {action}
        </div>
      )}
    </div>
  );
};

EmptyState.displayName = 'EmptyState';

export default EmptyState;